import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarAvisosRestricoesCliente(axios, parametros) {        
    parametros.operacao = 'buscarAvisosRestricoesCliente'

    let retorno = {};

    await axios.santriGET('/rest/orcamento', parametros, 15, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarAvisosRestricoesCliente.js